// extracted by mini-css-extract-plugin
export default {"signUp-button":"signUpButton_signUp-button__vjjft"};